import OptionGrid from "./OptionGrid";

export const optionGrid = {
  init: (store) => {
    const optionGrids = document.querySelectorAll(".sd-option-grid-wrapper");
    [...optionGrids].forEach((el) => new OptionGrid(el, store));
  },
};

export default optionGrid;
